module.exports = __webpack_public_path__ + "static/media/7x7BadOptimized.e9c35c58.jp2";